import { combineReducers } from 'redux'
import toastsReducer from "./toasts"
import activeRouteReducer from "./active_route"
import projectReducer from "./project"
import queriesReducer from "./queries"
import fontsInProjectReducer from "./fonts-in-project"
import elementsReducer from "./elements"
import * as formReducer from "./form"
import * as exportsReducers from "./exports"
import * as templateReducers from "template-edit/reducers"
import * as shapeListReducers from "shape-list/reducers"
import * as imagickFontsReducers from "./imagickFontsReduxList"
import * as shapeEditReducers from "shape-edit/reducers"
import * as productsAndExportReducers from "products/reducer"
import * as watermarkGroupsReducers from "watermark-groups/reducers"

import { undoRedoHistoryReducer } from "template-edit/undoRedoReducers"

function getReducers(bundle) {
    return Object.keys(bundle)
        .filter(key => key.indexOf("Reducer") > -1)
        .reduce((result, key) => {
            const name = key.replace("Reducer", "")
            result[name] = bundle[key];
            return result;
        }, {});
}

const rootReducers = {
    project: projectReducer,
    queries: queriesReducer,
    fontsInProject: fontsInProjectReducer,
    elements: elementsReducer,
    toasts: toastsReducer,
    activeRoute: activeRouteReducer,
    undoRedoHistory: undoRedoHistoryReducer,
    form: formReducer['formReducer'],
    ...getReducers(templateReducers),
    ...getReducers(shapeEditReducers),
    ...getReducers(productsAndExportReducers),
    ...getReducers(imagickFontsReducers),
    ...getReducers(shapeListReducers),
    ...getReducers(watermarkGroupsReducers),
    ...getReducers(exportsReducers),
}

export default combineReducers(rootReducers)
